import React from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";

const DEFAULT_IMG =
  "https://images.unsplash.com/photo-1552422535-c45813c61732?crop=entropy&cs=srgb&fm=jpg&q=85";

export const OneToOne = ({ image = DEFAULT_IMG }) => (
  <section className="mx-auto max-w-6xl px-4 sm:px-8" data-testid="one-to-one">
    <div className="grid overflow-hidden rounded-3xl border border-border bg-card lg:grid-cols-2">
      <div className="relative min-h-[240px]">
        <img src={image} alt="1:1 music lesson with Jason" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-card/70 to-transparent lg:bg-gradient-to-r" />
      </div>
      <div className="p-8 sm:p-10">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-primary">Private tuition</p>
        <h2 className="mt-2 font-serif text-3xl sm:text-4xl">1:1 sessions with Jason</h2>
        <p className="mt-3 text-muted-foreground">
          Personal, focused lessons tailored to you — ideal alongside the courses or to fast-track a specific goal.
        </p>
        <ul className="mt-5 space-y-2 text-sm">
          {[
            "Tailored to your instrument and level",
            "Real-time feedback on your reading and technique",
            "Flexible scheduling to fit around you",
          ].map((t) => (
            <li key={t} className="flex items-center gap-2 text-muted-foreground">
              <Check size={16} className="text-primary" /> {t}
            </li>
          ))}
        </ul>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <span className="font-serif text-2xl">
            £70<span className="text-base text-muted-foreground"> / hour</span>
          </span>
          <Link to="/pricing" data-testid="one-to-one-book">
            <Button className="rounded-full bg-primary px-6 py-6 text-base text-primary-foreground hover:bg-primary/90">
              <CalendarDays size={16} className="mr-2" /> Book a session <ArrowRight size={15} className="ml-2" />
            </Button>
          </Link>
          <Link to="/about">
            <Button variant="outline" className="rounded-full border-border px-6 py-6">
              Ask a question
            </Button>
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default OneToOne;
